export default (state = [], action) => {
  switch (action.type) {
    case "CREATE_OCCUPATION":
      return [...state, action.payload.occupation];
    case "UPDATE_OCCUPATIONS":
      return action.payload.occupations;
    case "DELETE_OCCUPATION":
      return state.filter((occupation) => {
        return occupation.id !== action.payload.occupation.id
      });
    default:
      return state;
  }
}
